/**
 * CHO THUÊ MÁY — công thức phải KHỚP server (cmd/mdmquery/owner.go → calcRent).
 *
 * LƯU Ý: rent_amount là TIỀN THUÊ CẢ HỢP ĐỒNG (không phải mỗi kỳ).
 *
 *   Tổng phí dịch vụ  = tiền thuê thiết bị + phí hồ sơ + phí giao nhận
 *   Thanh toán mỗi kỳ = tổng phí dịch vụ ÷ số kỳ            (làm tròn LÊN)
 *
 * Server LUÔN tính lại khi lưu (không tin số client gửi lên) — hai hàm dưới chỉ để
 * xem trước trên form.
 */
const n = (v) => { const x = Number(v); return isNaN(x) ? 0 : x; };

// Tổng phí thu MỘT LẦN: xử lý hồ sơ + giao nhận (giao nhận có thể bỏ trống).
export function rentFees(f) {
  return n(f.rent_doc_fee) + n(f.rent_ship_fee);
}

// Tổng phí dịch vụ cả hợp đồng (không phụ thuộc số kỳ). null khi chưa nhập tiền thuê.
export function rentTotal(f) {
  const amt = n(f.rent_amount);
  if (amt <= 0) return null;
  return amt + rentFees(f);
}

// Số tiền khách trả mỗi kỳ = tổng phí dịch vụ chia đều. null khi chưa đủ dữ liệu.
export function rentPerPeriod(f) {
  const periods = n(f.rent_periods);
  const total = rentTotal(f);
  if (periods <= 0 || total == null) return null;
  return Math.ceil(total / periods);
}

// Ngày kết thúc thuê = ngày enroll + số kỳ × (tuần | tháng).
export function rentEndDate(enrolledOn, periods, unit) {
  const p = n(periods);
  if (!enrolledOn || p <= 0) return '';
  const d = new Date(enrolledOn);
  if (isNaN(d)) return '';
  if (unit === 'week') d.setDate(d.getDate() + p * 7);
  else d.setMonth(d.getMonth() + p);
  return d.toISOString().slice(0, 10);
}

// Số kỳ thuê ĐÃ ĐẾN HẠN tính tới hôm nay (kỳ đầu = enroll + 1 kỳ), kẹp theo số kỳ thuê.
export function rentPeriodsElapsed(o) {
  if (!o || !o.enrolled_on || !o.rent_periods) return 0;
  const s = new Date(o.enrolled_on);
  if (isNaN(s)) return 0;
  const now = new Date();
  let k;
  if (o.rent_unit === 'week') {
    k = Math.floor((now - s) / (7 * 24 * 3600 * 1000));
  } else {
    k = (now.getFullYear() - s.getFullYear()) * 12 + (now.getMonth() - s.getMonth());
    if (now.getDate() < s.getDate()) k -= 1;
  }
  return Math.max(0, Math.min(k, n(o.rent_periods)));
}

export const UNIT_LABEL = { week: 'Tuần', month: 'Tháng' };

// Thứ trong tuần theo chuẩn ISO-8601: 1 = Thứ 2 … 7 = Chủ nhật.
// Dùng cho ô "Thứ thu tiền" khi kỳ thuê tính theo TUẦN.
export const WEEKDAYS = [
  { v: 1, label: 'Thứ 2' },
  { v: 2, label: 'Thứ 3' },
  { v: 3, label: 'Thứ 4' },
  { v: 4, label: 'Thứ 5' },
  { v: 5, label: 'Thứ 6' },
  { v: 6, label: 'Thứ 7' },
  { v: 7, label: 'Chủ nhật' },
];
export const weekdayLabel = (v) => (WEEKDAYS.find(d => d.v === Number(v)) || {}).label || '';
